import {
  MissingReportReminderType,
  MissingReportType,
} from 'api/types/missingInformationReportTypes';
import { routePaths } from 'components/Routes/data';
import { overlayLayers } from 'constants/overlayLayers.generated';

export const MODAL_OVER_DRAWER_Z_INDEX = overlayLayers.modal;

type MissingInformationSummaryTableData = {
  id: number;
  title: string;
  priority: 'high' | 'low';
  url: string;
  type: MissingReportType;
};

export const missingInformationSummaryTableData: MissingInformationSummaryTableData[] = [
  {
    id: 1,
    title: 'Unverified Bank Account Details',
    priority: 'high',
    url: routePaths.reports.missingInformation.unverifiedFailed,
    type: 'unverified_failed_bank_account_details',
  },
  {
    id: 2,
    title: 'Incorrect Bank Account Details',
    priority: 'high',
    url: routePaths.reports.missingInformation.incorrect,
    type: 'incorrect_bank_account_details',
  },
  {
    id: 3,
    title: 'Missing Bank Account Details',
    priority: 'high',
    url: routePaths.reports.missingInformation.bankAccount,
    type: 'bank_account_details',
  },
  {
    id: 4,
    title: 'Bank Account Name Mismatch',
    priority: 'high',
    url: routePaths.reports.missingInformation.nameMismatch,
    type: 'name_mismatch_bank_account_details',
  },
  {
    id: 5,
    title: 'Bank Accounts Pending Approval',
    priority: 'high',
    url: routePaths.approvalWorkflows.myRequests.employeeBankAccount.pendingApprovals,
    type: 'pending_approval_bank_account_details',
  },
  {
    id: 6,
    title: 'Statutory Contributions',
    priority: 'high',
    url: routePaths.reports.missingInformation.statutory,
    type: 'statutory_contributions',
  },
  {
    id: 7,
    title: 'Personal Details',
    priority: 'low',
    url: routePaths.reports.missingInformation.personal,
    type: 'personal_details',
  },
];

export const sendReminderModalDescriptions: Record<MissingReportReminderType, string> = {
  personal_details:
    'RazorpayX Payroll will email all employees in your organization with missing personal details.',
  bank_account_details:
    'RazorpayX Payroll will email all employees in your organization with missing/invalid bank account details.',
  statutory_contributions:
    'RazorpayX Payroll will email all employees in your organization with missing/invalid statutory contribution details.',
  incorrect_bank_account_details:
    'RazorpayX Payroll will email all employees in your organization with incorrect bank account details.',
};
